import Images from "../AllImages";

let Funds = [
  {
    asset: "BNB",
    Price: "10,098.36",
    FullName: "Binance",
    Yield_Rate: "7.46",
    Total_Balance: "0.2785689852",
    Available_Balance: "0.2785689853",
    Interest: "0.2785689854",
    image: Images.bnb,
  },
  {
    asset: "BTC",
    Price: "10,098.36",
    FullName: "Tether USD",
    Yield_Rate: "7.46",
    Total_Balance: "0.2785689854",
    Available_Balance: "0.2785689853",
    Interest: "0.2785689855",
    image: Images.btc,
  },
  {
    asset: "USDT",
    Price: "10,098.36",
    FullName: "Tether USD",
    Yield_Rate: "7.46",
    Total_Balance: "0.2785689855",
    Available_Balance: "0.2785689852",
    Interest: "0.2785689852",
    image: Images.tether,
  },
  {
    asset: "USDT",
    Price: "10,098.36",
    FullName: "Tether USD",
    Yield_Rate: "7.46",
    Total_Balance: "0.27856898521",
    Available_Balance: "0.27856898522",
    Interest: "0.2785689852",
    image: Images.tether,
  },
  {
    asset: "USDT",
    Price: "10,098.36",
    FullName: "Tether USD",
    Yield_Rate: "7.46",
    Total_Balance: "0.27856898522",
    Available_Balance: "0.27856898526",
    Interest: "0.2785689852",
    image: Images.tether,
  },
  {
    asset: "USDT",
    Price: "10,098.36",
    FullName: "Tether USD",
    Yield_Rate: "7.46",
    Total_Balance: "0.2785689852",
    Available_Balance: "0.2785689852",
    Interest: "0.2785689852",
    image: Images.tether,
  },
  {
    asset: "BNB",
    Price: "10,098.36",
    FullName: "Binance",
    Yield_Rate: "7.46",
    Total_Balance: "0.2785689852",
    Available_Balance: "0.2785689852",
    Interest: "0.2785689852",
    image: Images.bnb,
  },
];

export default Funds;
